import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Skeleton from 'react-loading-skeleton'
import ConfirmPopup from './../modal/modal';
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getUnits, stripHTML, getClientLongName, setConfig, getConfig, getYesNo } from "../../utils"
import cloneDeep from 'lodash/cloneDeep';


const ProjectsAdmin = () => {

    let navigate = useNavigate();
    const { projectsStore } = useStores();
    const { getAll, projects, remove, duplicate, getAllWithOptions, /*setConfig, config*/ } = projectsStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);

    /*useEffect(() => {
        setIsLoading(true);
        async function fetchMyAPI() {
            getAll().then(() => {
                setIsLoading(false);
            });
        }

        fetchMyAPI();
    }, [getAll]);*/
    /**useEffect(() => {
        alert(templates?.results?.length?.toString())
    }, [templates?.results])*/

    const onPageChange = (props) => {
        var newProps = cloneDeep(props);

        newProps.filterBy?.filters?.forEach(main => {
            main?.filters?.forEach(f => {
                /*if (["workUnit", "billingUnit", "salaryUnit"].indexOf(f.field) > -1) {
                    f.value = getUnitOptions()?.find(x => x.text == f.value)?.value;
                }*/

            });
        });
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }

    return (
        <ManagementTable name={t('projects')} ref={tableRef} isLoading={isLoading}

            config={{
                size: getConfig("projects", "size"),
                dataState: getConfig("projects", "dataState")
            }}
            onColumnSizeChange={(c) => setConfig("projects", "size", c)}
            onDataStateChange={(c) => { setConfig("projects", "dataState", c) }}

            //filters={["name", "startDate", "endDate", "client", "validator"]}
            /*onDelete={(id) => {
                remove(id).then(() => { tableRef?.current?.resetPage() })
            }}*/
            /*onEdit={(id) => {
                alert(id)
            }}*/
            items={projects?.results} onPageChange={onPageChange} pageCount={projects?.pageCount} total={projects?.count} pageSize={projects?.pageSize} columns={
                [
                    { name: "projectName",prop:"name"},
                    { name: "startDate", fn: (v) => `${v.split("-")[1]}.${v.split("-")[0]}`,type:"month",filter:"date"},
                    { name: "endDate", fn: (v) => `${v.split("-")[1]}.${v.split("-")[0]}`, type: "month", filter: "date" },
                    { name: "client", fn: (v) => getClientLongName(v) },
                    { name: "validator", fn: (v) => v ? `${v.name} ${v.surname}` : "-" },
                    /*{ name: "code" },
                    { name: "company", fn: (v) => v.name },
                    { name: "currency", fn: (v) => getCurrencies().find(x => x.id == v)?.name },
                    { name: "corporateName" }*/

                ]}
            extraButtons={
                [
                    { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },
                    { text: t('copy'), icon: solid("copy"), onClick: (id) => { duplicate(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmCopy"), modalTitle: t("copy") },
                    { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                ]
            }
        />

    );


};

export default observer(ProjectsAdmin);
